const optionsTotemVersion = [
  {
    version: 'v1',
    name: 'totem_version_whyline',
  },
  {
    version: 'v2',
    name: 'totem_version_banco_macro',
  },
];

const getTotemInfoByVersion = (version) => {
  return optionsTotemVersion.find(totem => totem.version === version);
}

module.exports = {
  optionsTotemVersion,
  getTotemInfoByVersion,
};
